import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-licensing',
  templateUrl: './licensing.component.html',
  styleUrls: ['./licensing.component.css']
})
export class LicensingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
